module.exports = __webpack_public_path__ + "img/dashboard-active.2cf649ea.svg";